import React from "react";

const Spinner = () => {
  return (
    <>
      <div className="preloader">
        <div className="spinner">{/* <h1>Loading...</h1>{" "} */}</div>
      </div>
    </>
  );
};

export default Spinner;
